import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
interface APIURLInfo {
  apiBaseUrl: string
  domain?: string
  hostName?: string
  apiDocUrl: string
  pluginsPageUrl: string
  defaultLogoUrlWhite: string
  defaultLogoUrlBlack: string
  websiteUrl: string
  appUrl: string
  sandboxMerchantUrl: string
  devMerchantUrl: string
  productionMerchantUrl: string
  staticResourceRoot: string
}
export const useGeneralStore = defineStore('general', () => {
  let domainInfo = reactive<APIURLInfo>({
    apiBaseUrl: '',
    domain: '',
    hostName: '',
    apiDocUrl: '',
    pluginsPageUrl: '',
    defaultLogoUrlWhite: '',
    defaultLogoUrlBlack: '',
    websiteUrl: '',
    appUrl: '',
    sandboxMerchantUrl: '',
    devMerchantUrl: '',
    productionMerchantUrl: '',
    staticResourceRoot: ''
  })
  const theme = ref('system')
  const colorSchema = ref('light')
  const isDarkMode = ref(false)
  const languageList = ref([
    { code: 'zh', name: 'Chinese' },
    { code: 'da', name: 'Danish' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'el', name: 'Greek' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'pl', name: 'Polish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'ru', name: 'Russian' },
    { code: 'es', name: 'Spanish' },
    { code: 'sv', name: 'Swedish' },
    { code: 'tr', name: 'Turkish' }
  ])
  const rtlClass = ref('ltr')
  const locale = ref('en')
  const getDomainInfo = computed(() => domainInfo)
  const getTheme = computed(() => theme.value)
  const getLanguageList = computed(() => languageList.value)
  const getColorSchema = computed(() => colorSchema.value)
  const SET_DOMAIN_INFO = (par: APIURLInfo) => {
    domainInfo = par
  }
  const TOGGLE_THEME = (payload: string) => {
    theme.value = payload
    localStorage.setItem('theme', payload)
    if (payload === 'system') {
      isDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches
    }
    if (payload === 'dark') {
      isDarkMode.value = true
    }
    if (payload === 'light') {
      isDarkMode.value = false
    }

    if (isDarkMode.value) {
      colorSchema.value = 'dark'
      document.documentElement.classList.remove('light')
      document.documentElement.classList.add('dark')
    } else {
      colorSchema.value = 'light'
      document.documentElement.classList.remove('dark')
      document.documentElement.classList.add('light')
    }
  }
  const TOGGLE_RTLCLASS = (payload: string) => {
    localStorage.setItem('rtl', payload)
    rtlClass.value = payload
    document.querySelector('html')?.setAttribute('dir', payload)
  }
  const SET_LOCALE = (payload: string) => {
    localStorage.setItem('lang', payload)
    locale.value = payload
    document.querySelector('html')?.setAttribute('lang', payload)
  }
  return {
    getDomainInfo,
    SET_DOMAIN_INFO,
    TOGGLE_THEME,
    getTheme,
    colorSchema,
    TOGGLE_RTLCLASS,
    SET_LOCALE,
    getColorSchema,
    getLanguageList
  }
})
